module.exports = __webpack_public_path__ + "img/trash.d2ec919f.svg";